module.exports = __webpack_public_path__ + "img/Jump Casting67.024cdc8e.jpg";